module.exports = __webpack_public_path__ + "img/w3_circle_right_white.53518256.png";